import { render, staticRenderFns } from "./PrivacyBatteryChargeAlarm.vue?vue&type=template&id=1b5c299b&scoped=true"
import script from "./PrivacyBatteryChargeAlarm.vue?vue&type=script&lang=js"
export * from "./PrivacyBatteryChargeAlarm.vue?vue&type=script&lang=js"
import style0 from "./PrivacyBatteryChargeAlarm.vue?vue&type=style&index=0&id=1b5c299b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c299b",
  null
  
)

export default component.exports